import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var DocumentFolderApi = /** @class */ (function () {
    function DocumentFolderApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    DocumentFolderApi.initialize = function (basePath, fetchApi) {
        if (!DocumentFolderApi.instance) {
            DocumentFolderApi.instance = new DocumentFolderApi(basePath, fetchApi);
        }
        return DocumentFolderApi.instance;
    };
    DocumentFolderApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1DocumentFolderApi(new Configuration(config));
    };
    return DocumentFolderApi;
}());
export { DocumentFolderApi };
